module.exports = __webpack_public_path__ + "static/media/Worker_Supplier_new.ed101fe5.jpg";